import styles from "./AccountSearchPage.module.css";
import StyledRadioButton from "../../modules/common/inputs/StyledRadioButton";
import classNames from "classnames";
import { Channel } from "../../lib/api/models";
import { useChannelState } from "../../lib/channelContext";
import { ChannelMapToFull } from "../../lib/channelUtil";

const strings = {
  title: "Search",

  channel: "Channel",
  channelLegend:
    "Select a channel to use while editting the account you select.",
};

const channels: Channel[] = ["INB", "TRN", "OUT", "RES", "COR"];
const channelOptions: { value: Channel; label: string }[] = channels.map(
  (channel) => ({ value: channel, label: ChannelMapToFull[channel] }),
);

export default function ChannelForm() {
  const { channel, setChannel } = useChannelState();

  return (
    <form className={styles.channelContainer}>
      <div className={styles.channelContent}>
        <h2 className={classNames(styles.heading, styles.channelHeading)}>
          {strings.channel}
        </h2>
        <fieldset className={styles.channelFieldSet}>
          <legend className={styles.channelLegend}>
            {strings.channelLegend}
          </legend>
          {channelOptions.map((item) => (
            <StyledRadioButton
              key={item.value}
              label={item.label}
              value={item.value}
              onChange={() => setChannel(item.value)}
              checked={item.value === channel}
            />
          ))}
        </fieldset>
      </div>
    </form>
  );
}
